import React from "react"
import Layout from "../components/App/Layout"
import Navbar from "../components/App/Navbar"
import PageBanner from "../components/Common/PageBanner"
import Footer from "../components/App/Footer"
// import gallery1 from '../assets/images/gallery/gallery1.jpg'
// import gallery2 from '../assets/images/gallery/gallery2.jpg'
// import gallery3 from '../assets/images/gallery/gallery3.jpg'
// import gallery4 from '../assets/images/gallery/gallery4.jpg'
// import gallery5 from '../assets/images/gallery/gallery5.jpg'
// import gallery6 from '../assets/images/gallery/gallery6.jpg'
// import gallery7 from '../assets/images/gallery/gallery7.jpg'
// import gallery8 from '../assets/images/gallery/gallery8.jpg'
// import gallery9 from '../assets/images/gallery/gallery9.jpg'
import Lightbox from "react-image-lightbox"

import { Link, graphql, useStaticQuery } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import Loadable from "@loadable/component"
// Import custom timeline CSS
import "../assets/css/life-timeline.css"

const OwlCarousel = Loadable(() => import("react-owl-carousel3"))

const options = {
  loop: true,
  nav: true,
  dots: false,
  autoplayHoverPause: true,
  autoplay: true,
  items: 3,
  navText: [
    // "<i class='flaticon-left-1'></i>",
    // "<i class='flaticon-right-1'></i>"
  ],
}

const query = graphql`
  {
    allStrapiLifeAtCompanies(
      filter: {}
      sort: { fields: createdAt, order: DESC }
    ) {
      nodes {
        festival
        bannerImg {
          localFile {
            childImageSharp {
              original {
                src
              }
            }
          }
        }
        Decription
      }
    }
  }
`

function LifeStSrashtasoft() {
  const [photoIndex, setPhotoIndex] = React.useState(0)
  const [isOpenImage, setIsOpenImage] = React.useState(false)

  const data = useStaticQuery(query)
  const life_at_details = data.allStrapiLifeAtCompanies.nodes
  // const data = life_at_details.map(i => i.bannerImg.localFile.childImageSharp.original.src)

  // console.log(`imgs`, imgs)

  return (
    <Layout>
      <Navbar />
      <PageBanner
        pageTitle="Life At Srashtasoft"
        homePageText="Home"
        homePageUrl="/"
        activePageText="Life At Srashtasoft"
      />

      <div className="gallery-area pt-50 pb-70">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title text-center mb-5">
                <h2>Our Company Events & Celebrations</h2>
                <p>
                  Discover the vibrant culture and exciting events that make
                  Srashtasoft a great place to work
                </p>
              </div>

              <ol className="timeline life-timeline">
                {life_at_details.map((item, index) => (
                  <li className="timeline-block" key={index}>
                    <div className="timeline-row">
                      {/* For mobile view - always show image first, then content */}
                      <div className="d-block d-md-none">
                        <div className="timeline-image mobile-view">
                          <img
                            src={
                              item.bannerImg.localFile.childImageSharp.original
                                .src
                            }
                            alt={item.festival}
                            style={{
                              width: "100%",
                              height: "auto",
                              objectFit: "contain",
                              borderRadius: "10px",
                            }}
                          />
                        </div>
                        <div className="timeline-card mobile-view">
                          <h3>{item.festival}</h3>
                          <p>{item.Decription}</p>
                          <div className="mt-3">
                            <a
                              className="default-btn"
                              href={`/life-at-srashtasoft/${item.festival}`}
                            >
                              Explore More
                              <i className="ri-arrow-right-line"></i>
                            </a>
                          </div>
                        </div>
                      </div>

                      {/* Desktop view - original alternating layout */}
                      <div className="d-none d-md-flex">
                        {/* Left Side */}
                        <div className={`timeline-side left`}>
                          {index % 2 === 0 ? (
                            <div className="timeline-card">
                              <h3>{item.festival}</h3>
                              <p>{item.Decription}</p>
                              <div className="mt-3">
                                <a
                                  className="default-btn"
                                  href={`/life-at-srashtasoft/${item.festival}`}
                                >
                                  Explore More
                                  <i className="ri-arrow-right-line"></i>
                                </a>
                              </div>
                            </div>
                          ) : (
                            <div className="timeline-image">
                              <img
                                src={
                                  item.bannerImg.localFile.childImageSharp
                                    .original.src
                                }
                                alt={item.festival}
                                style={{
                                  width: "100%",
                                  height: "auto",
                                  objectFit: "contain",
                                  borderRadius: "10px",
                                }}
                              />
                            </div>
                          )}
                        </div>

                        {/* Center Line */}
                        <div className="timeline-center">
                          <span className="timeline-dot"></span>
                          <span className="timeline-line"></span>
                        </div>

                        {/* Right Side */}
                        <div className={`timeline-side right`}>
                          {index % 2 !== 0 ? (
                            <div className="timeline-card">
                              <h3>{item.festival}</h3>
                              <p>{item.Decription}</p>
                              <div className="mt-3">
                                <a
                                  className="default-btn"
                                  href={`/life-at-srashtasoft/${item.festival}`}
                                >
                                  Explore More
                                  <i className="ri-arrow-right-line"></i>
                                </a>
                              </div>
                            </div>
                          ) : (
                            <div className="timeline-image">
                              <img
                                src={
                                  item.bannerImg.localFile.childImageSharp
                                    .original.src
                                }
                                alt={item.festival}
                                style={{
                                  width: "100%",
                                  height: "auto",
                                  objectFit: "contain",
                                  borderRadius: "10px",
                                }}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </li>
                ))}
              </ol>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </Layout>
  )
}

export default LifeStSrashtasoft
